// Internationalization - Multi-language content

export const translations = {
  pt: {
    nav: {
      home: "Início",
      about: "Quem somos",
      services: "Serviços",
      contact: "Contato",
      blog: "Blog",
      tracking: "Rastreio",
      quote: "Cotação"
    },
    hero: {
      title: "Logística sem fronteiras",
      subtitle: "Encontre a melhor opção logística para o seu negócio, com soluções personalizadas e estratégicas.",
      cta: "SOBRE NÓS"
    },
    stats: {
      label: "A WELL CARGO EM NÚMEROS",
      title: "Já movimentamos",
      sea: "PELO MAR",
      air: "PELO AR",
      countries: "PAÍSES"
    },
    merchandise: {
      line1: "Embarcamos mais de 8.000 tipos de mercadorias.",
      line2: "Café, vinho, granito, carne, cargas",
      line3: "perigosas, e muito mais."
    },
    about: {
      title: "Solução de Comércio Exterior para todos os Segmentos",
      badge: "Somos a Well Cargo",
      cardTitle: "Seu transporte,",
      cardHighlight: "nossa priopridade.",
      cardSubtitle: "You transport, our priority"
    },
    services: {
      title: "Saiba mais sobre nossos serviços",
      viewAll: "VER TODOS OS SERVIÇOS",
      air: "Transporte Aéreo",
      sea: "Transporte Marítimo",
      road: "Transporte Rodoviário",
      otherTitle: "Outros serviços",
      cta: "Entre em contato!"
    },
    contact: {
      title: "Contato",
      subtitle: "Entre em contato conosco",
      formTitle: "Envie sua mensagem",
      name: "Nome",
      email: "E-mail",
      phone: "Telefone",
      company: "Empresa",
      message: "Mensagem",
      send: "Enviar mensagem",
      success: "Mensagem enviada com sucesso! Entraremos em contato em breve.",
      infoTitle: "Informações de contato",
      officesTitle: "Nossos escritórios"
    },
    tracking: {
      title: "Rastreie sua Carga",
      subtitle: "Acompanhe sua mercadoria",
      placeholder: "Digite o código de rastreio",
      button: "Rastrear",
      status: "Status",
      origin: "Origem",
      destination: "Destino",
      eta: "Previsão de Entrega"
    },
    quote: {
      title: "Solicite uma Cotação",
      subtitle: "Receba uma proposta personalizada",
      origin: "Origem",
      destination: "Destino",
      cargoType: "Tipo de Carga",
      weight: "Peso (kg)",
      transport: "Tipo de Transporte",
      calculate: "Calcular Estimativa",
      result: "Estimativa de Frete",
      disclaimer: "*Valores estimados. Cotação final sujeita a análise."
    },
    footer: {
      copyright: "© Well Cargo, 2025",
      address: "Endereço"
    },
    loading: {
      text: "Carregando..."
    }
  },
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      services: "Services",
      contact: "Contact",
      blog: "Blog",
      tracking: "Tracking",
      quote: "Quote"
    },
    hero: {
      title: "Logistics without borders",
      subtitle: "Find the best logistics solution for your business, with personalized and strategic solutions.",
      cta: "ABOUT US"
    },
    stats: {
      label: "WELL CARGO IN NUMBERS",
      title: "We have moved",
      sea: "BY SEA",
      air: "BY AIR",
      countries: "COUNTRIES"
    },
    merchandise: {
      line1: "We ship over 8,000 types of goods.",
      line2: "Coffee, wine, granite, meat, hazardous",
      line3: "cargo, and much more."
    },
    about: {
      title: "Foreign Trade Solutions for All Segments",
      badge: "We are Well Cargo",
      cardTitle: "Your transport,",
      cardHighlight: "our priority.",
      cardSubtitle: "Seu transporte, nossa prioridade"
    },
    services: {
      title: "Learn more about our services",
      viewAll: "VIEW ALL SERVICES",
      air: "Air Transport",
      sea: "Sea Transport",
      road: "Road Transport",
      otherTitle: "Other services",
      cta: "Contact us!"
    },
    contact: {
      title: "Contact",
      subtitle: "Get in touch with us",
      formTitle: "Send your message",
      name: "Name",
      email: "Email",
      phone: "Phone",
      company: "Company",
      message: "Message",
      send: "Send message",
      success: "Message sent successfully! We will contact you soon.",
      infoTitle: "Contact information",
      officesTitle: "Our offices"
    },
    tracking: {
      title: "Track your Cargo",
      subtitle: "Follow your goods",
      placeholder: "Enter tracking code",
      button: "Track",
      status: "Status",
      origin: "Origin",
      destination: "Destination",
      eta: "Estimated Delivery"
    },
    quote: {
      title: "Request a Quote",
      subtitle: "Receive a personalized proposal",
      origin: "Origin",
      destination: "Destination",
      cargoType: "Cargo Type",
      weight: "Weight (kg)",
      transport: "Transport Type",
      calculate: "Calculate Estimate",
      result: "Freight Estimate",
      disclaimer: "*Estimated values. Final quote subject to analysis."
    },
    footer: {
      copyright: "© Well Cargo, 2025",
      address: "Address"
    },
    loading: {
      text: "Loading..."
    }
  },
  es: {
    nav: {
      home: "Inicio",
      about: "Quiénes somos",
      services: "Servicios",
      contact: "Contacto",
      blog: "Blog",
      tracking: "Rastreo",
      quote: "Cotización"
    },
    hero: {
      title: "Logística sin fronteras",
      subtitle: "Encuentre la mejor opción logística para su negocio, con soluciones personalizadas y estratégicas.",
      cta: "SOBRE NOSOTROS"
    },
    stats: {
      label: "WELL CARGO EN NÚMEROS",
      title: "Ya movimos",
      sea: "POR MAR",
      air: "POR AIRE",
      countries: "PAÍSES"
    },
    merchandise: {
      line1: "Embarcamos más de 8.000 tipos de mercancías.",
      line2: "Café, vino, granito, carne, cargas",
      line3: "peligrosas, y mucho más."
    },
    about: {
      title: "Solución de Comercio Exterior para todos los Segmentos",
      badge: "Somos Well Cargo",
      cardTitle: "Tu transporte,",
      cardHighlight: "nuestra prioridad.",
      cardSubtitle: "Your transport, our priority"
    },
    services: {
      title: "Conozca más sobre nuestros servicios",
      viewAll: "VER TODOS LOS SERVICIOS",
      air: "Transporte Aéreo",
      sea: "Transporte Marítimo",
      road: "Transporte Terrestre",
      otherTitle: "Otros servicios",
      cta: "¡Contáctenos!"
    },
    contact: {
      title: "Contacto",
      subtitle: "Póngase en contacto con nosotros",
      formTitle: "Envíe su mensaje",
      name: "Nombre",
      email: "Correo electrónico",
      phone: "Teléfono",
      company: "Empresa",
      message: "Mensaje",
      send: "Enviar mensaje",
      success: "¡Mensaje enviado con éxito! Nos pondremos en contacto pronto.",
      infoTitle: "Información de contacto",
      officesTitle: "Nuestras oficinas"
    },
    tracking: {
      title: "Rastree su Carga",
      subtitle: "Siga su mercancía en tiempo real",
      placeholder: "Ingrese el código de rastreo",
      button: "Rastrear",
      status: "Estado",
      origin: "Origen",
      destination: "Destino",
      eta: "Entrega Estimada"
    },
    quote: {
      title: "Solicite una Cotización",
      subtitle: "Reciba una propuesta personalizada",
      origin: "Origen",
      destination: "Destino",
      cargoType: "Tipo de Carga",
      weight: "Peso (kg)",
      transport: "Tipo de Transporte",
      calculate: "Calcular Estimación",
      result: "Estimación de Flete",
      disclaimer: "*Valores estimados. Cotización final sujeta a análisis."
    },
    footer: {
      copyright: "© Well Cargo, 2025",
      address: "Dirección"
    },
    loading: {
      text: "Cargando..."
    }
  }
};

export const partners = [
  { id: 1, name: "WCA World", logo: "https://customer-assets.emergentagent.com/job_global-shipping-22/artifacts/s8xmakb6_SELO%20WCA%20WORLD.jpg" },
  { id: 2, name: "IATA", logo: "https://customer-assets.emergentagent.com/job_global-shipping-22/artifacts/mlok2810_SELO%20IATA%20.png" },
  { id: 3, name: "WCA World", logo: "https://customer-assets.emergentagent.com/job_global-shipping-22/artifacts/s8xmakb6_SELO%20WCA%20WORLD.jpg" },
  { id: 4, name: "IATA", logo: "https://customer-assets.emergentagent.com/job_global-shipping-22/artifacts/mlok2810_SELO%20IATA%20.png" },
  { id: 5, name: "WCA World", logo: "https://customer-assets.emergentagent.com/job_global-shipping-22/artifacts/s8xmakb6_SELO%20WCA%20WORLD.jpg" },
  { id: 6, name: "IATA", logo: "https://customer-assets.emergentagent.com/job_global-shipping-22/artifacts/mlok2810_SELO%20IATA%20.png" },
  { id: 7, name: "WCA World", logo: "https://customer-assets.emergentagent.com/job_global-shipping-22/artifacts/s8xmakb6_SELO%20WCA%20WORLD.jpg" },
  { id: 8, name: "IATA", logo: "https://customer-assets.emergentagent.com/job_global-shipping-22/artifacts/mlok2810_SELO%20IATA%20.png" }
];

export const testimonials = [
  {
    id: 1,
    name: "Coordenador de Logística",
    company: "Trading Company",
    text: "A Well Cargo sempre foi muito parceira nas nossas importações. A equipe acompanha os embarques de perto, avisa qualquer mudança e resolve rápido quando aparece algum imprevisto. Isso dá muita tranquilidade pra gente trabalhar.",
    rating: 5,
    avatar: "https://randomuser.me/api/portraits/men/32.jpg"
  },
  {
    id: 2,
    name: "Importador",
    company: "Setor de Rochas Ornamentais",
    text: "Nosso produto é pesado e exige cuidado no transporte internacional. Com a Well Cargo, a gente sente segurança. Eles cuidam dos detalhes e mantêm a gente informado o tempo todo. Já passamos por situações difíceis e sempre tivemos apoio.",
    rating: 5,
    avatar: "https://randomuser.me/api/portraits/men/67.jpg"
  },
  {
    id: 3,
    name: "Exportador Brasileiro",
    company: "Setor Industrial",
    text: "Na exportação, prazo e alinhamento são tudo. A Well Cargo acompanha nossos embarques de perto, ajuda na definição das melhores rotas e sempre busca alternativas quando o mercado aperta. A gente sente que não é só mais um cliente, é uma parceria de longo prazo, construída com confiança e resultado.",
    rating: 5,
    avatar: "https://randomuser.me/api/portraits/men/45.jpg"
  },
  {
    id: 4,
    name: "Agente Internacional",
    company: "América Latina (México)",
    text: "Como agente no México, precisamos de parceiros no Brasil que sejam organizados e ágeis. A Well Cargo mantém a comunicação clara, envia as instruções completas e acompanha os embarques até o destino final. Isso facilita muito nossa operação e fortalece a confiança entre as equipes dos dois países.",
    rating: 5,
    avatar: "https://randomuser.me/api/portraits/women/44.jpg"
  }
];

export const trackingMockData = {
  "WC123456789": {
    status: "in_transit",
    statusText: { pt: "Em Trânsito", en: "In Transit", es: "En Tránsito" },
    origin: "Santos, Brasil",
    destination: "Rotterdam, Holanda",
    eta: "2025-02-15",
    progress: 65,
    history: [
      { date: "2025-01-20", event: { pt: "Carga coletada", en: "Cargo collected", es: "Carga recolectada" }, location: "São Paulo, BR" },
      { date: "2025-01-22", event: { pt: "Em trânsito para o porto", en: "In transit to port", es: "En tránsito al puerto" }, location: "Santos, BR" },
      { date: "2025-01-25", event: { pt: "Embarcado no navio", en: "Loaded on vessel", es: "Cargado en el barco" }, location: "Porto de Santos" },
      { date: "2025-01-28", event: { pt: "Em alto mar", en: "At sea", es: "En alta mar" }, location: "Atlântico" }
    ]
  },
  "WC987654321": {
    status: "delivered",
    statusText: { pt: "Entregue", en: "Delivered", es: "Entregado" },
    origin: "Xangai, China",
    destination: "São Paulo, Brasil",
    eta: "2025-01-10",
    progress: 100,
    history: [
      { date: "2024-12-15", event: { pt: "Carga coletada", en: "Cargo collected", es: "Carga recolectada" }, location: "Xangai, CN" },
      { date: "2024-12-20", event: { pt: "Embarcado", en: "Shipped", es: "Embarcado" }, location: "Porto de Xangai" },
      { date: "2025-01-08", event: { pt: "Chegou ao destino", en: "Arrived at destination", es: "Llegó al destino" }, location: "Santos, BR" },
      { date: "2025-01-10", event: { pt: "Entregue", en: "Delivered", es: "Entregado" }, location: "São Paulo, BR" }
    ]
  }
};

export const globalRoutes = [
  { from: { lat: -23.9, lng: -46.3, name: "Santos" }, to: { lat: 51.9, lng: 4.5, name: "Rotterdam" } },
  { from: { lat: -23.9, lng: -46.3, name: "Santos" }, to: { lat: 31.2, lng: 121.5, name: "Shanghai" } },
  { from: { lat: -23.9, lng: -46.3, name: "Santos" }, to: { lat: 40.7, lng: -74.0, name: "New York" } },
  { from: { lat: -23.9, lng: -46.3, name: "Santos" }, to: { lat: 35.6, lng: 139.7, name: "Tokyo" } },
  { from: { lat: -23.9, lng: -46.3, name: "Santos" }, to: { lat: 1.3, lng: 103.8, name: "Singapore" } },
  { from: { lat: -23.9, lng: -46.3, name: "Santos" }, to: { lat: 51.5, lng: -0.1, name: "London" } }
];
